<!--
  @Author: Yu Xiujie
  @Desc: 官网专题推广页
  @Date: 2022-07-18
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{titleName}}</span></mMenusNav>
    <!-- bannar -->
    <van-swipe :autoplay="3000" :show-indicators="false">
      <van-swipe-item>
        <div class="index_bg" @click="openMath">
          <!-- 轮播图存放样式 -->
          <img
            src="../../../static/mobile/mExtensionPage/wap_banner_1.png"
            alt=""
          />
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="index_bg" @click="openMath">
          <!-- 轮播图存放样式 -->
          <img
            src="../../../static/mobile/mExtensionPage/wap_banner_2.png"
            alt=""
          />
        </div>
      </van-swipe-item>
    </van-swipe>

    <!-- 慧用工｜免费获取定制方案 -->
    <mFromPage
    :source="paramQuery.source"
      ><span class="pop-box-title">慧用工｜免费获取定制方案</span></mFromPage
    >

    <!-- 一键解决企业难题 -->
    <div class="bag-image" @click="openMath">
      <img src="../../../static/mobile/mExtensionPage/wap_home_3.png" alt="" />
      <img src="../../../static/mobile/mExtensionPage/wap_home_4.png" alt="" />
      <img src="../../../static/mobile/mExtensionPage/wap_home_5.png" alt="" />
    </div>

    <!-- 合作伙伴 -->
    <div class="partner" @click="openMath">
      <div class="title">合作伙伴</div>
      <div class="img">
        <img src="../../../static/mobile/index/img_hezuohuoban.png" alt="" />
      </div>
    </div>

    <!--立即预约-->
    <div class="appointment">
      <div class="information">
        <mFromPage
        :source="paramQuery.source"
          ><span class="pop-box-title"
            >慧用工｜致力于助力每一个优秀的公司</span
          ></mFromPage
        >
      </div>
    </div>

    <!-- form弹窗 -->
    <mFrom :source="paramQuery.source"></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import mFromPage from "../../components/mFromPage";
import { checkNull } from "../../filters/filters";
import {
  BANNER_CAN_DO,
  BANNER_SERVICE,
  MAP_CON_LIST,
} from "../../service/businessConsts";

export default {
  name: 'mExtension-page',
  data() {
    return {
      current: 0,
      paramQuery: {
        name: "",
        phone: "",
        companyName: "",
        source: "",
        bdVid: "",
      },
      titleName: "",
      timerTemp: null,
      mapArray: MAP_CON_LIST,
      whichCompName: "",
    };
  },

  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
    mFromPage: mFromPage,
  },

  created() {
    this.compInfo = this.getSiteAddress();
    if(!checkNull(this.$route.query.bd_vid)){
      if (this.$route.query.bd_vid.length > 1) {
        this.paramQuery.bdVid = this.$route.query.bd_vid[1];
      }else{
        this.paramQuery.bdVid = this.$route.query.bd_vid
      }
    }
    
    // source来源：：
    let hash = window.location.hash;
    this.paramQuery.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mjjfa_zttg' : '&pageFrom=mjjfa_zttg';
  },

  mounted() {
  },

  methods: {

    // 地图数字
    getMapNumMth() {
      this.mapArray[0].numberTemp = 20;
      this.mapArray[1].numberTemp = 3680;
      this.mapArray[2].numberTemp = 2;
      this.mapArray[3].numberTemp = 49;
      this.getMapTimerMth();
    },

    //地图数字
    getMapTimerMth() {
      this.timerTemp = setInterval(
        () =>
          this.mapArray.forEach((item) => {
            item.numberTemp++;
            if (item.numberTemp == item.number) {
              clearInterval(this.timerTemp);
              this.mapArray[0].numberTemp = 40;
              this.mapArray[1].numberTemp = 3700;
              this.mapArray[2].numberTemp = 20;
              this.mapArray[3].numberTemp = 68;
            }
          }),
        100
      );
    },
    openMath() {
      eventBus.$emit("operaDiaLog", true);
    },
  },

  beforeDestroy() {
    clearInterval(this.timerTemp);
  },
};
</script>

<style>
</style>

<style lang="scss" scoped>
.page-main {
  padding: 0;
  margin: 0;
}
.index_bg {
  width: 100%;
  height: 990px;
  overflow: hidden;
  background: linear-gradient(180deg, #100f0f 0%, #002979 100%);
  img {
    margin: 98px auto 0;
    width: 750px;
  }
}

.bag-image {
  padding: 0;
  margin: 0;
  width: 100%;
  img {
    width: 100%;
  }
}

.partner {
  width: 100%;
  height: 748px;
  overflow: hidden;
  background: #fbfdff;
  .title {
    margin: 70px auto 32px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100f0f;
    line-height: 56px;
  }
  .img {
    margin: 0 auto;
    // width: 690px;
    height: 559px;
    img {
      // width: 100%;
      height: 100%;
    }
  }
}

.appointment {
  width: 100%;
  height: 930px;
  overflow: hidden;
  background-image: url(../../../static/mobile/index/img_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #f9fbfd;
  .information {
    margin: 110px 30px 58px;
    height: 662px;
    background: #ffffff;
    border-radius: 16px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/mobile/mExtensionPage.vue